import { FormGroup } from '@angular/forms';

export function validateForm(group: FormGroup, formErrors: any, validationMessages: any): void {
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    formErrors[key] = '';
    if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
      const messages = validationMessages[key];
      for (const errorKey in abstractControl.errors) {
        if (errorKey) {
          formErrors[key] += messages[errorKey] + ' ';
        }
      }
    }
  })
}

export function validateFormWithoutMessages(group: FormGroup, formErrors: any): void {
  Object.keys(group.controls).forEach(key => {
    group.get(key).markAsTouched();
  });

  group.valueChanges.subscribe(changes => {
    Object.keys(changes).forEach(controlName => {
      const control = group.controls[controlName];
      formErrors[controlName] = ((control.touched || control.dirty) && control.errors)
        ? 'error'
        : null;
    });
  });
}
